import { CoverageTypeEnum } from "@platform/types";
import { useEffect, useRef } from "react";

// Proposals are fetched once for the whole RFP and filtered client-side per
// coverage, so switching LOC alone never issues a new request. Force a fresh
// round trip on every LOC switch (skipping the initial mount, which
// useProposals already fetches) so rates/premiums reflect the latest server
// state instead of a potentially stale cached payload.
export const useRefetchProposalsOnLocChange = (
  selectedCoverageType: CoverageTypeEnum | undefined,
  refetchProposals: () => unknown,
): void => {
  const isMountRef = useRef(true);
  useEffect(() => {
    if (isMountRef.current) {
      isMountRef.current = false;
      return;
    }
    if (selectedCoverageType) {
      void refetchProposals();
    }
  }, [selectedCoverageType, refetchProposals]);
};
